// extracted by mini-css-extract-plugin
export default {"button":"styles_button__-yzyr","icon":"styles_icon__n84MM","buttonPadded":"styles_button-padded__xx1Vs"};